import { css } from "@emotion/react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useAccount } from "../store/account";
import PaidFeatureButton from "./PaidFeatureButton";

export default function Help() {
    const { data: account = {} } = useAccount();
    return (
        <>
            <Helmet>
                <title>Help / Support - Podtrac</title>
            </Helmet>
            <h1>Help / Support</h1>
            <p>
                Need help getting Podtrac measurement working for your show? Want to learn more
                about how Podtrac measurement works? Have questions about the Podtrac Grow Your Show
                plan? Or maybe you have questions about podcast measurement in general.
            </p>
            <p>
                Whatever your need, we are here to help. Here are the ways you can get the support
                you need to understand your podcast metrics and grow your show.
            </p>

            <div
                css={css`
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    grid-gap: 1rem 3rem;
                `}
            >
                <h2>Help Center & Knowledge Base</h2>
                <h2>Email Support</h2>
                <h2>Office Hours</h2>

                <p>
                    Browse articles to get detailed information on how to implement Podtrac
                    measurement as well as how to understand and use Podtrac reports.
                </p>
                <p>Send us an email for personalized help with your Podtrac account.</p>
                <p>
                    Scheduled weekly Zoom office hours are available as part of our Grow Your Show
                    plan to provide 1-on-1 realtime support. Check our schedule to find a time that
                    works for you.
                </p>

                <p>
                    <b>
                        <a href="https://podtrac.freshdesk.com/support/solutions" target="_blank">
                            Visit Knowledge Base
                        </a>
                    </b>
                </p>
                <div>
                    <p>
                        <b>
                            Email us at{" "}
                            <a href="mailto:support@podtrac.com" target="_blank">
                                support@podtrac.com
                            </a>
                        </b>
                    </p>
                </div>
                <p>
                    <b>
                        <PaidFeatureButton
                            hasFeature={account.isPaidPlan}
                            dialogContent="Zoom office hours is a premium feature available in the Grow Your Show Plan."
                        >
                            {({ hasFeature, openModal }) => (
                                <Link
                                    to="../office-hours"
                                    onClick={hasFeature ? () => {} : openModal}
                                >
                                    View Office Hours Schedule
                                </Link>
                            )}
                        </PaidFeatureButton>
                    </b>
                </p>
            </div>
        </>
    );
}
